import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Logos/home-main.svg";
import Particle from "../Atom";
import Home2 from "./HomeContainer";
import Type from "./HomeCard";
import laptopImg from "../../Logos/about.svg";
import Resume from "../Resume";
import Button from "react-bootstrap/Button";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function Home() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);
  return (      
    
    <div>
      <Container fluid className="homecontainer" >
      <Particle />  
        <Container className="homesubcontainer">
          <Row>
          <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src='https://www.mangoitsolutions.com/wp-content/uploads/2021/02/full-stack-dev-expert-img.png'
                alt="homeimage"
                className="homepic"
                style={{ maxHeight: "750px", marginTop:'80px',width:'80%'}}
              />
            </Col>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="hello">Hii there! {" "}</h1>

              <h1 className="strong">
                I'm
                <strong className="name" style={{color:"aqua"}}> Rutuja Lomate</strong>
              </h1>

               <div style={{  textAlign: "left",padding: 40 ,marginTop:"-20px"}}>
                <h2 style={{color:"aqua",fontSize:'20px'}}>Full Stack Web Developer</h2>
          
              </div> 
            </Col>

            
          </Row>
        </Container>
      </Container>
      
      {/* <Home2 /> */}
  </div>
  );
}

export default Home;
